import { render } from "./FormActivity.vue?vue&type=template&id=fbfa2d70&ts=true"
import script from "./FormActivity.vue?vue&type=script&lang=ts"
export * from "./FormActivity.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__